import React, { PureComponent } from 'react';
import ReactEcharts from 'echarts-for-react';
import { Popover, Button } from 'antd';
import ActionPopver from './ActionPopver'
import styles from "./voltageGauge.module.less";

const colorGreen = '#78a355'
const colorRed = '#ef4136'
const colorOrange = '#faa755'
export default class VoltageGauge extends PureComponent {
    state = {
        popVisible: false,
        popKey: 0,
    }

    static defaultProps = {
        axisLineColor: [[0.45, colorOrange], [0.6, colorGreen], [1, colorRed]]
    };


    onSubmit = (data) => {
        const { onActionSubmit } = this.props;
        onActionSubmit && onActionSubmit(data, _ => this.setState({ popVisible: false }))
    }
    renderPopverContent = () => {
        const { filed, action, defaultValue, deviceId, loadDefaultValue } = this.props;
        return <div>
            <ActionPopver title={filed + '电压'} action={action} onSubmit={this.onSubmit}
                loadDefaultValue={loadDefaultValue} defaultValue={defaultValue} deviceId={deviceId} />

        </div>

    }

    render() {
        const { data, filed, action } = this.props;
        const { Value = {}, MaxThr = {}, MinThr = {}, AlarmSw = {}, Status = {} } = data || {}
        const min = MinThr.value;
        const max = MaxThr.value;
        const value = Value.value || 0;
        const alarmSw = AlarmSw.value;

        const seriesMin = 180
        const seriesMax = 270
        const axisLineColor = [
            [(min - seriesMin) / (seriesMax - seriesMin), colorOrange],
            [(max - seriesMin) / (seriesMax - seriesMin), colorGreen],
            [1, colorRed]
        ]

        // const name = getName({min, max, value})
        const name = Status.value || '';
        const color = getColor(name)
        const optionData = [{ value, name: filed + name }]
        const { popVisible, popKey } = this.state;
        const option = {
            textStyle: { color: '#BFBFBF', fontFamily: 'Microsoft YaHei', fontWeight: 100 },
            series: [
                {
                    name: '电压',
                    type: 'gauge',
                    startAngle: 225,
                    endAngle: -45,
                    min: 180,
                    max: 270,
                    splitNumber: 6,
                    radius: '93%',
                    axisTick: { // 刻度
                        show: true,
                        splitNumber: 5,// 数量
                        length: '8%', // 长度
                        lineStyle: {
                            width: '1',
                            color: '#000',
                            opacity: 0.3
                        }

                    },
                    splitLine: {
                        show: true,
                        length: '10%',
                        lineStyle: {
                            width: '2',
                            color: '#000',
                            opacity: 0.3
                        }
                    },
                    axisLabel: { // 刻度值
                        show: true,
                        textStyle: {
                            fontSize: 0.12 * window.fontSize
                        }
                    },
                    pointer: { // 指针
                        show: true,
                        length: '92%',
                        width: 2,
                    },
                    title: { // 标题
                        show: false,
                        offsetCenter: [0, '-38%'],
                        color: color,
                        fontSize: 14,
                        fontWeight: 'bold'
                    },
                    detail: {
                        show: false,
                        offsetCenter: [0, "28%"],
                        width: 65,
                        height: 25,
                        textStyle: {
                            fontSize: 12,
                            color: "#fff",
                            fontWeight: "bolder",

                        },
                        borderWidth: 2,
                        borderRadius: 2,
                        borderColor: "#fff",
                        color: '#000',
                    },
                    axisLine: {
                        lineStyle: {
                            width: '6',
                            color: axisLineColor
                        }
                    },
                    itemStyle: {
                        color: 'white',
                        borderColor: 'white',
                        shadowBlur: 1,
                        opacity: 1
                    },
                    data: optionData
                },
                {
                    type: 'gauge',
                    name: '外层辅助白',
                    radius: '100%',
                    startAngle: '269.9',
                    endAngle: '-90.09',
                    pointer: {
                        show: false
                    },
                    detail: {
                        show: false,
                    },
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: [
                                [1, '#ddd']
                            ],
                            width: 2,
                            opacity: 1
                        }
                    },
                    axisTick: {
                        show: false
                    },
                    splitLine: {
                        show: false,
                    },
                    axisLabel: {
                        show: false
                    }
                },
                {
                    type: 'gauge',
                    name: '外层辅助黑',
                    radius: '98%',
                    startAngle: '269.9',
                    endAngle: '-90.09',
                    pointer: {
                        show: false
                    },
                    detail: {
                        show: false,
                    },
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: [
                                [1, '#555']
                            ],
                            width: 0,
                            opacity: 0
                        }
                    },
                    axisTick: {
                        show: false
                    },
                    splitLine: {
                        show: false,
                    },
                    axisLabel: {
                        show: false
                    }
                },
            ]
        };

        return (
            <div className={styles.voltageGaugeMain} >
                <div className={styles.top} >
                    <ReactEcharts option={option} style={{ height: '100%' }} />
                </div>
                <div className={styles.down} >
                    <div className={styles.valueDiv} style={{ color: color }}>
                        {`${filed + name}:`}
                        <span className={styles.value} style={{ color: color }}>{value}V</span>
                    </div>
                    {action ? (
                        <div className={styles.buttonDiv}>
                            <Popover key={popKey} trigger="click" visible={popVisible}
                                content={this.renderPopverContent()}
                                onVisibleChange={(popVisible) => this.setState({ popVisible, popKey: popKey + 1 })}>
                                <Button type="primary" className={styles.button}>设置</Button>
                            </Popover>
                        </div>
                    ) : ''}
                </div>
            </div>
        )
    }
}

function getName({ min, max, value }) {
    if (value < min) return '欠压'
    if (value > max) return '过压'
    return '正常'
}



function getColor(name) {
    const ret = {
        '正常': colorGreen,
        '欠压': colorOrange,
        '过压': colorRed,
    }
    return ret[name] || 'gray'
}